<div id="forms" class="page-layout simple fullwidth" fxLayout="column">

    <div class="content">
        <!-- CONTENT HEADER -->
        <div class="header primary p-24" fxLayout="row" fxLayoutAlign="start center">
            <h2 class="m-0">{{'REQUERIMIENTOSV3.CABECERA.TITULO' | translate}}</h2>
        </div>
        <!-- / CONTENT HEADER -->

        <div class="horizontal-stepper-wrapper p-20">
          <!-- <div  class="" fxLayout="column" fxLayoutAlign="start stretch">
              <mat-progress-bar mode="determinate" value="{{porcentajeAvance}}"></mat-progress-bar>
              <h4 class="mt-0 mb-10 midText">{{'REQUERIMIENTOS.VALIDACION.TIMELINE.PROGRESO2' | translate}} {{porcentajeAvance}}%</h4>
          </div> -->

            <!-- HORIZONTAL STEPPER EXAMPLE -->
            <mat-horizontal-stepper class="mat-elevation-z4" [linear]="true">
             <!-- requerimientos Nuevos -->
                <!-- <mat-step [stepControl]="">

                    <form fxLayout="column">

                        <ng-template matStepLabel>{{'REQUERIMIENTOSV3.PASO1.TITULO' | translate}}</ng-template>

                        <div fxFlex="1 0 auto" fxLayout="column">
                          <div fxLayout="row" fxLayoutAlign="center center" >
                          <img src="./assets/images/requerimientos.png" alt="" style="width:70%;">
                          </div>
                          <p style="font-size:  40px;font-weight:bold;margin:0;">{{'REQUERIMIENTOSV3.PASO1.SUB_TITULO' | translate}}</p>
                          <p style="font-size: 40px;color:#F5A71E;font-weight:bold;margin:0;">{{'REQUERIMIENTOSV3.PASO1.SUB_TITULO2' | translate}}</p>
                          <p style="font-size: 23px;margin:0;">{{'REQUERIMIENTOSV3.PASO1.TEXTO0_PARTE_1' | translate}}</p>
                          <p style="font-size: 23px;margin:0;">{{'REQUERIMIENTOSV3.PASO1.TEXTO0_PARTE_2' | translate}}</p>

                          <div class="" fxLayout="column" fxLayoutAlign="start start">
                            <p style="font-size: 20px;color:#F5A71E;font-weight:bold;margin:20;">{{'REQUERIMIENTOSV3.PASO1.SUB_TITULO3' | translate}}</p>
                            <p style="font-size: 15px;font-weight:bold">{{'REQUERIMIENTOSV3.PASO1.SUB_TITULO4' | translate}}</p>
                          </div>
                            <table id="myTable">
                                <tr>
                                    <td style="width:40%; background-color: #f1f1f1">{{'REQUERIMIENTOSV3.PASO1.TABLE_REQUERIMIENTOS.TD_SISTEMAS' | translate}}</td>
                                    <td style="width:60%; background-color: #f1f1f1">• Microsoft Windows 7 {{'REQUERIMIENTOSV3.PASO1.TABLE_REQUERIMIENTOS.TD_LABEL_RECOMENDADO' | translate}}<br> • MacOS 10.10.5 <br> • Android 6.0 {{'REQUERIMIENTOSV3.PASO1.TABLE_REQUERIMIENTOS.TD_LABEL_SUPERIOR' | translate}}
                                        <br> • iOs 7.1.2 {{'REQUERIMIENTOSV3.PASO1.TABLE_REQUERIMIENTOS.TD_LABEL_SUPERIOR' | translate}}<br>
                                    </td>
                                </tr>
                                <tr>
                                    <td>{{'REQUERIMIENTOSV3.PASO1.TABLE_REQUERIMIENTOS.TD_NAVEGADOR' | translate}}</td>
                                    <td>• Google Chrome {{'REQUERIMIENTOSV3.PASO1.TABLE_REQUERIMIENTOS.TD_LABEL_LASTVERSION' | translate}} <br> • Mozilla Firefox {{'REQUERIMIENTOSV3.PASO1.TABLE_REQUERIMIENTOS.TD_LABEL_LASTVERSION' | translate}} <br> • Apple Safari
                                        {{'REQUERIMIENTOSV3.PASO1.TABLE_REQUERIMIENTOS.TD_LABEL_LASTVERSION_MIN' | translate}}<br> • Microsoft Edge<br>
                                    </td>
                                </tr>

                            </table>
                            <br>
                            <p>{{'REQUERIMIENTOSV3.PASO1.TEXTO1_PARTE_1' | translate}}</p>
                            <p>{{'REQUERIMIENTOSV3.PASO1.TEXTO1_PARTE_2' | translate}}</p>

                            <p>{{'REQUERIMIENTOSV3.PASO1.TEXTO2_PARTE_1' | translate}}</p>

                          </div>
                          <div fxLayout="row" fxLayoutAlign="center center">
                            <button mat-raised-button color="primary" matStepperNext>
                          {{'REQUERIMIENTOSV3.BOTONES.SIGUIENTE' | translate}}
                          </button>
                          </div>

                          </form>
                          <img style="width:100%"src="./assets/images/Fondo.png" alt="">


                </mat-step> -->



                <mat-step>

                    <form fxLayout="column">

                        <ng-template matStepLabel>{{'REQUERIMIENTOSV3.PASO2.TITULO' | translate}}</ng-template>

                        <div fxFlex="1 0 auto" fxLayout="column">
                          <ng-container [ngSwitch]="idiomasRtInstituto">
                            <ng-container *ngSwitchCase="'CAyC'">
                              <p style="font-size:  40px;margin:0px;">{{'REQUERIMIENTOSV3.PASO2.SUB_TITULO2_CARCA' | translate}}{{'REQUERIMIENTOSV3.PASO2.SUB_TITULO1' | translate}}</p>
                              <p>{{'REQUERIMIENTOSV3.PASO2.TEXTO0_PARTE_1_CARCA' | translate}}</p>
                              <p>{{'REQUERIMIENTOSV3.PASO2.TEXTO1_PARTE_1_CARCA' | translate}}</p>
                            </ng-container>
                            <ng-container *ngSwitchCase="'2'">
                              <p style="font-size:  40px;margin:0px;">{{'REQUERIMIENTOSV3.PASO2.SUB_TITULO2_CARCA' | translate}}{{'REQUERIMIENTOSV3.PASO2.SUB_TITULO1' | translate}}</p>
                              <p>{{'REQUERIMIENTOSV3.PASO2.TEXTO0_PARTE_1_CARCA' | translate}}</p>
                              <p>{{'REQUERIMIENTOSV3.PASO2.TEXTO1_PARTE_1_CARCA' | translate}}</p>
                            </ng-container>
                            <ng-container *ngSwitchDefault>
                              <p style="font-size:  40px;margin:0px;">{{'REQUERIMIENTOSV3.PASO2.SUB_TITULO2' | translate}}{{'REQUERIMIENTOSV3.PASO2.SUB_TITULO1' | translate}}</p>
                              <p>{{'REQUERIMIENTOSV3.PASO2.TEXTO0_PARTE_1' | translate}}</p>
                              <p>{{'REQUERIMIENTOSV3.PASO2.TEXTO1_PARTE_1' | translate}}</p>
                            </ng-container>

                          </ng-container>
                        <br>
                        </div>

                        <table class="egt" style="width:100%;">

                          <tr>
                            <th style="border: 1px solid black;margin:0px" colspan="3">{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TH_ELEMENTO' | translate}}</th>
                            <th style="border: 1px solid black;margin:0px">{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TH_REGIONM' | translate}}</th>
                            <!-- <th style="border: 1px solid black;margin:0px">{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TH_REGIONC' | translate}}</th>
                            <th style="border: 1px solid black;margin:0px">{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TH_REGIONA' | translate}}</th>
                            <th style="border: 1px solid black;margin:0px">{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TH_REGIONE' | translate}}</th> -->
                          </tr>

                          <tr>
                            <th style="border: 1px solid black;margin:0px" colspan="3">{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TH_DOMINIO_PRINCIPAL' | translate}}</th>
                            <th style="border: 1px solid black;margin:0px">culturalgo.com</th>
                          </tr>
                             <!-- Inicio Contenido Aplicador de Encuesta  -->
                          <tr>
                            <th rowspan="3" style="border: 1px solid black;margin:0px">
                            {{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TH_APLICADOR' | translate}}
                            </th>
                            <th rowspan="3" style="border: 1px solid black;margin:0px">
                                <button mat-raised-button color="accent" style="margin-left:30px" (click)="testConection(1)" *ngIf="!newsurvey"  matTooltipClass="tooltipRanking" >
                                <!-- <button mat-raised-button color="accent" style="margin-left:30px" (click)="verificarConexion(1)" *ngIf="!newsurvey"  matTooltipClass="tooltipRanking" matTooltip="{{'REQUERIMIENTOSV3.PASO2.TOOL_BTN_COMPRO_CONEX' | translate}}" matTooltipPosition="below"> -->
                                  {{'REQUERIMIENTOSV3.PASO2.BTN_COMPRO_CONEX' | translate}}
                                  <mat-icon class="ml-20 ">wifi_tethering</mat-icon>
                                </button>
                                <button mat-raised-button class="done" *ngIf="newsurvey">
                                   {{'REQUERIMIENTOSV3.PASO2.BTN_SUCCE_CONEX' | translate}}
                                  <mat-icon class="ml-20 ">verified_user</mat-icon>
                                </button>
                            </th>
                            <th style="border: 1px solid black;margin:0px">{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TH_SUBDOMINIO' | translate}}</th>
                            <th style="border: 1px solid black;margin:0px">newsurvey.culturalgo.com</th>
                          <tr>
                            <th style="border: 1px solid black;margin:0px">{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TH_DIRECCION_IP' | translate}}</th>
                            <th style="border: 1px solid black;margin:0px">35.247.154.187</th>
                          </tr>
                          <tr>
                            <th style="border: 1px solid black;margin:0px">{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TH_PUERTOS' | translate}}</th>
                            <th style="border: 1px solid black;margin:0px">80 y 443</th>
                          </tr>
                          <!-- Fin Contenido Aplicador de Encuesta  -->
                          <!-- Inicio Contenido Plataforma de Administracion  -->
                          <tr>
                            <th rowspan="3" colspan="2" style="border: 1px solid black;margin:0px">
                            {{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TH_PLATAFORMA' | translate}}
                            </th>
                            <th style="border: 1px solid black;margin:0px"rowspan="1">{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TH_SUBDOMINIO' | translate}}</th>
                            <th style="border: 1px solid black;margin:0px">app04.culturalgo.com</th>
                            </tr>
                          <!-- <tr><th style="border: 1px solid black;margin:0px">back04.culturalgo.com</th></tr> -->

                          <tr>
                            <th style="border: 1px solid black;margin:0px"rowspan="1">{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TH_DIRECCION_IP' | translate}}</th>
                            <th style="border: 1px solid black;margin:0px">35.247.131.159</th>
                          </tr>
                          <!-- <tr><th style="border: 1px solid black;margin:0px">35.197.141.96</th></tr> -->
                          <tr>
                            <th style="border: 1px solid black;margin:0px">{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TH_PUERTOS' | translate}}</th>
                            <th style="border: 1px solid black;margin:0px">443</th>
                          </tr>
                          <!-- Fin Contenido Plataforma de Administracion  -->
                          <!-- Inicio Contenido Envoltura de URL  -->
                          <tr>
                            <th rowspan="3" style="border: 1px solid black;margin:0px">
                            {{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TH_ENVOLTURA' | translate}}
                            </th>
                            <th rowspan="3" style="border: 1px solid black;margin:0px">
                              <button mat-raised-button color="accent" style="margin-left:30px" (click)="testConection(2)" *ngIf="!forAllGptw" >
                                  {{'REQUERIMIENTOSV3.PASO2.BTN_COMPRO_CONEX' | translate}}
                                  <mat-icon class="ml-20 ">wifi_tethering</mat-icon>
                                </button>
                                <button mat-raised-button class="done" *ngIf="forAllGptw">
                                   {{'REQUERIMIENTOSV3.PASO2.BTN_SUCCE_CONEX' | translate}}
                                  <mat-icon class="ml-20 ">verified_user</mat-icon>
                                </button>
                            </th>
                            <th style="border: 1px solid black;margin:0px">{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TH_DOMINIO' | translate}}</th>
                            <th style="border: 1px solid black;margin:0px">4all.gptw.global</th>


                          </tr>

                          <tr>
                            <th style="border: 1px solid black;margin:0px">{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TH_DIRECCION_IP' | translate}}</th>
                            <th style="border: 1px solid black;margin:0px">35.240.163.121</th>

                          </tr>
                          <tr>
                            <th style="border: 1px solid black;margin:0px">{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TH_PUERTOS' | translate}}</th>
                            <th style="border: 1px solid black;margin:0px">80 y 443</th>

                          </tr>
                          <!-- Fin Contenido Envoltura de URL  -->
                          <!-- Inicio Contenido Resultados Tablou R  -->
                          <tr>
                            <th rowspan="3" style="border: 1px solid black;margin:0px">
                            {{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TH_RESULTADOS' | translate}}
                            </th>
                            <th rowspan="3" style="border: 1px solid black;margin:0px">
                            <button mat-raised-button color="accent" style="margin-left:30px" (click)="testConection(3)" *ngIf="!graphics04" >
                                  {{'REQUERIMIENTOSV3.PASO2.BTN_COMPRO_CONEX' | translate}}
                                  <mat-icon class="ml-20 ">wifi_tethering</mat-icon>
                            </button>
                            <button mat-raised-button class="done" *ngIf="graphics04">
                               {{'REQUERIMIENTOSV3.PASO2.BTN_SUCCE_CONEX' | translate}}
                              <mat-icon class="ml-20 ">verified_user</mat-icon>
                            </button>
                            </th>
                            <th style="border: 1px solid black;margin:0px">{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TH_SUBDOMINIO' | translate}}</th>
                            <th style="border: 1px solid black;margin:0px">graphics04.culturalgo.com</th>


                          </tr>

                          <tr>
                            <th style="border: 1px solid black;margin:0px">{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TH_DIRECCION_IP' | translate}}</th>
                            <th style="border: 1px solid black;margin:0px">34.87.16.113</th>

                          </tr>
                          <tr>
                            <th style="border: 1px solid black;margin:0px">{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TH_PUERTOS' | translate}}</th>
                            <th style="border: 1px solid black;margin:0px">8443</th>

                          </tr>
                          <!-- Fin Contenido Resultados (Tablou R)  -->
                          <!-- Inicio Contenido Culture Audit r  -->
                          <tr>
                            <th rowspan="3" style="border: 1px solid black;margin:0px">
                              {{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TH_CULTURE' | translate}}
                            </th>
                            <th rowspan="3" style="border: 1px solid black;margin:0px">
                            <button mat-raised-button color="accent" style="margin-left:30px" (click)="testConection(4)" *ngIf="!culture04" >
                                  {{'REQUERIMIENTOSV3.PASO2.BTN_COMPRO_CONEX' | translate}}
                                  <mat-icon class="ml-20 ">wifi_tethering</mat-icon>
                                </button>
                                <button mat-raised-button class="done" *ngIf="culture04">
                                   {{'REQUERIMIENTOSV3.PASO2.BTN_SUCCE_CONEX' | translate}}
                                  <mat-icon class="ml-20 ">verified_user</mat-icon>
                                </button>
                            </th>
                            <th style="border: 1px solid black;margin:0px">{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TH_SUBDOMINIO' | translate}}</th>
                            <th style="border: 1px solid black;margin:0px">culture04.culturalgo.com</th>
                            </tr>

                          <tr>
                            <th style="border: 1px solid black;margin:0px">{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TH_DIRECCION_IP' | translate}}</th>
                            <th style="border: 1px solid black;margin:0px">34.124.145.16</th>

                          </tr>
                          <tr>
                            <th style="border: 1px solid black;margin:0px">{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TH_PUERTOS' | translate}}</th>
                            <th style="border: 1px solid black;margin:0px">8443</th>

                          </tr>
                          <!-- Fin Contenido Culture Audit r  -->

                          <!-- Inicio Contenido Portal de conteos Externo  -->
                          <tr>
                            <th rowspan="3" colspan="2" style="border: 1px solid black;margin:0px">{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TH_PORTAL' | translate}}
                            </th>
                            <th style="border: 1px solid black;margin:0px"rowspan="1">{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TH_SUBDOMINIO' | translate}}</th>
                            <th style="border: 1px solid black;margin:0px">app04.culturalgo.com</th></tr>
                          <!-- <tr><th style="border: 1px solid black;margin:0px">back04.culturalgo.com</th></tr> -->

                          <tr>
                            <th style="border: 1px solid black;margin:0px"rowspan="1">{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TH_DIRECCION_IP' | translate}}</th>
                            <th style="border: 1px solid black;margin:0px">35.247.131.159</th>
                          </tr>
                          <!-- <tr><th style="border: 1px solid black;margin:0px">35.197.141.96</th></tr> -->
                          <tr>
                            <th style="border: 1px solid black;margin:0px">{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TH_PUERTOS' | translate}}</th>
                            <th style="border: 1px solid black;margin:0px">443</th>

                          </tr>


                        </table>

                        <p>{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TEXTO1' | translate}}</p>
                        <p>{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TEXTO2' | translate}}</p>
                        <p>{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TEXTO3' | translate}}</p>
                        <p>{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TEXTO4' | translate}}</p>
                        <p>{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TEXTO5' | translate}}</p>
                        <p>{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TEXTO6' | translate}}</p>

                         <ng-container [ngSwitch]="idiomasRtInstituto">
                           <h1 *ngSwitchCase="'CAyC'"> {{'REQUERIMIENTOSV3.PASO2.SUB_TITULO2_CARCA' | translate}} {{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TEXTO7' | translate}}</h1>
                           <h1 *ngSwitchCase="'2'"> {{'REQUERIMIENTOSV3.PASO2.SUB_TITULO2_CARCA' | translate}}{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TEXTO7' | translate}}</h1>
                           <h1 *ngSwitchDefault> {{'REQUERIMIENTOSV3.PASO2.SUB_TITULO2' | translate}} {{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TEXTO7' | translate}}</h1>
                           </ng-container>
                         <p>{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TEXTO8' | translate}}</p>
                         <p>{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TEXTO9' | translate}}</p>
                         <table>
                             <tr>
                                 <td style="width:40%; background-color: #f1f1f1">{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TABLA_CONTENT2.TD_CUENTA_CORREO' | translate}}</td>
                                 <ng-container [ngSwitch]="idiomasRtInstituto">
                                   <td style="width:60%; background-color: #f1f1f1" *ngSwitchCase="'CAyC'">non-reply@gptwonline.com<br></td>
                                   <td style="width:60%; background-color: #f1f1f1" *ngSwitchCase="'2'">non-reply@gptwonline.com<br></td>
                                   <td style="width:60%; background-color: #f1f1f1" *ngSwitchDefault>no-reply@gptwonline.com<br></td>
                                   </ng-container>
                             </tr>
                             <tr>
                                 <td>{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TABLA_CONTENT2.TD_DOMINIO' | translate}}</td>
                                 <td>em7632.gptwonline.com</td>
                             </tr>

                             <!-- IpAddress Primary -->
                             <ng-container>
                               <tr>
                                 <td style="background-color: #f1f1f1">{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TABLA_CONTENT2.TD_IP_ADDRE_PRIM' | translate}}</td>
                                 <td style="background-color: #f1f1f1"><code>168.245.113.112</code></td>
                               </tr>

                             </ng-container>

                             <!-- IpAddress Seconds -->
                             <ng-container>
                               <tr>
                                 <td rowspan="3">{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TABLA_CONTENT2.TD_SECON_IP' | translate}}</td>
                                 <td><code>168.245.22.233</code></td>
                               </tr>
                               <tr>
                                 <td><code>149.72.154.98</code></td>
                               </tr>
                               <tr>
                                 <td><code>149.72.190.59</code></td>
                               </tr>
                             </ng-container>


                             <!-- Subdominio -->
                             <ng-container>
                             <tr>
                                 <td rowspan="3" style="background-color: #f1f1f1">{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TABLA_CONTENT2.TD_SUBDOMINIO' | translate}}</td>
                                 <td style="background-color: #f1f1f1">url2414.gptwonline.com</td>
                             </tr>
                             <tr>
                               <td style="background-color: #f1f1f1">url2612.gptwonline.com</td>
                             </tr>
                             <tr>
                               <td style="background-color: #f1f1f1">url7217.gptwonline.com</td>
                             </tr>
                           </ng-container>
                         </table>

                         <p>{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TEXTO10' | translate}}</p>
                         <p>{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TEXTO11' | translate}}</p>
                         <p>{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TEXTO12' | translate}}</p>
                         <span style="font-weight: 700;">{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TEXTO13' | translate}}  <span style="font-size: 17px; color:#e40601">support@itbm.mx</span></span>


                     <!-- <ng-container *ngIf="tipoUsuarioAdministrador">
                       <div fxLayout="row" fxLayoutAlign="center center">
                       <button mat-raised-button color="primary" matStepperPrevious>
                         {{'REQUERIMIENTOSV3.BOTONES.ANTERIOR' | translate}}
                       </button>
                       <button mat-raised-button color="primary" matStepperNext class="ml-20">
                         {{'REQUERIMIENTOSV3.BOTONES.SIGUIENTE' | translate}}
                       </button>
                         </div>
                     </ng-container>
                     <ng-container *ngIf="!tipoUsuarioAdministrador">
                       <div fxLayout="row" fxLayoutAlign="center center">
                         <button class="mr-8" mat-raised-button color="primary" matStepperPrevious>
                           {{'REQUERIMIENTOSV3.BOTONES.ANTERIOR' | translate}}
                         </button>
                         <button mat-raised-button color="primary" *ngIf="!autenticacionEncuesta"  (click)="setBanderasRequerimientos('auten')" [disabled]="!siguiente">
                           {{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.BTN_CONFIGURACION' | translate}}
                         </button>
                         <button mat-raised-button color="primary" matStepperNext *ngIf="autenticacionEncuesta" >
                           {{'REQUERIMIENTOSV3.BOTONES.SIGUIENTE' | translate}}
                         </button>
                       </div>
                     </ng-container> -->

                    </form>

                </mat-step>


                <!-- <mat-step [stepControl]="">

                        <ng-template matStepLabel>{{'REQUERIMIENTOSV3.PASO3.TITULO' | translate}}</ng-template>
                        <div fxLayout="column" fxLayoutAlign="start center">
                            <h2>{{'REQUERIMIENTOSV3.PASO3.TIT_TES_PRU_ACC_SURV' | translate}}</h2>
                            <mat-card>
                                <div fxLayout="row" fxLayoutAlign="start start">
                                    <h3 class="h3 secondary-text" style="font-weight:bold;">{{'REQUERIMIENTOSV3.PASO3.INS1_TES_PRU_ACC_SURV' | translate}}</h3> &nbsp;
                                    <h3 style="font-weight:bold;"><a href="{{urlEncuesta}}" target="_blank">{{urlEncuesta}}</a></h3>
                                </div>

                                <div fxLayout="row" fxLayoutAlign="center center" >
                                    <ng-container >
                                      <button mat-raised-button class="mb-20" (click)="saveUserSurveyRequerimientosTecnicos()" [disabled]="tipoUsuarioAdministrador">
                                        {{'REQUERIMIENTOSV3.PASO3.INS1_1_TES_PRU_ACC_SURV' | translate}} {{userEncuesta}}
                                        <mat-icon class="ml-20 ">file_copy</mat-icon>
                                      </button>
                                    </ng-container>


                                </div>
                                <div fxLayout="row" fxLayoutAlign="start center">
                                    <h3 class="h3 secondary-text" style="font-weight:bold;">{{'REQUERIMIENTOSV3.PASO3.INS2_TES_PRU_ACC_SURV' | translate}}</h3>
                                </div>
                                <mat-divider></mat-divider>

                                <div fxLayout="row" fxLayoutAlign="start center">
                                    <h3 class="h3 secondary-text" style="font-weight:bold;">{{'REQUERIMIENTOSV3.PASO3.INS3_TES_PRU_ACC_SURV' | translate}}</h3>
                                </div>
                                <mat-divider></mat-divider>

                                <div fxLayout="row" fxLayoutAlign="start center">
                                    <h3 class="h3 secondary-text" style="font-weight:bold;">{{'REQUERIMIENTOSV3.PASO3.INS4_TES_PRU_ACC_SURV' | translate}}</h3>
                                </div>
                                <mat-divider></mat-divider>
                                  <div class="contactoSoporte" fxLayout="row"  style="margin-top:20px">
                                  <mat-icon matSuffix>help</mat-icon>
                                  {{'REQUERIMIENTOSV3.PASO3.CONTAC' | translate}}
                                  </div>
                                <mat-divider></mat-divider>
                                <div class="" fxLayout="row" fxLayoutAlign="center center" style="margin-top:10px">
                                    <button  mat-raised-button color="accent" [disabled]="tipoUsuarioAdministrador || visualizarEncuesta" (click)="setBanderasRequerimientos('access')">
                                      {{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.BTN_ACCESO_ENCUESTA' | translate}}
                                    </button>
                                </div>


                            </mat-card>
                        </div>

                        <div fxLayout="column" fxLayoutAlign="center center">
                        <h2 style="padding-left:20px;">{{'REQUERIMIENTOSV3.PASO3.TIT_TES_PRU_EM_PILO' | translate}}</h2>
                        <mat-card>
                        <div fxLayout="column" fxLayoutAlign="start stretch">
                          <div fxLayout="column" fxLayoutAlign="center center">
                          <h3 class="h3 secondary-text" style="font-weight:bold;">{{'REQUERIMIENTOSV3.PASO3.INS1_TES_PRU_EM_PILO' | translate}}</h3>
                          </div>
                          <mat-divider></mat-divider>
                          <div fxLayout="column" fxLayoutAlign="center center">
                          <h3 class="h3 secondary-text" style="font-weight:bold;">{{'REQUERIMIENTOSV3.PASO3.INS2_TES_PRU_EM_PILO' | translate}}</h3>
                          </div>
                          <mat-divider></mat-divider>

                          <div *ngFor="let correo of correosPilotos; let i = index;" fxLayout="p-15 row" fxLayoutAlign="center center">
                            <mat-form-field class="p-5" fxFlex="60">
                              <mat-error>Campo requerido</mat-error>
                              <input type="email" matInput placeholder="{{'DISPATCH.LABEL03' | translate}}" [(ngModel)]="correosPilotos[i].email" (blur)="validarDato($event,i)">
                              <mat-icon matSuffix>email</mat-icon>
                            </mat-form-field>
                          </div>
                          <mat-divider></mat-divider>

                          <div fxLayout="p-15 row" fxLayoutAlign="center center">
                            <button mat-raised-button color="accent" (click)="enviaPilotos();" [disabled]="recibiCorreosEncuesta || tipoUsuarioAdministrador">{{'REQUERIMIENTOSV3.PASO3.BTN_SE_EMA' | translate}}</button>
                          </div>
                          <mat-divider></mat-divider>
                          <div *ngIf="!testEmail"  class="statusDivAlert" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}" fxFlex="70">
                            <div class="roundEdg alert mat-elevation-z4 pr-20 pl-20 font-size-24 font-weight-300 line-height-1" fxLayout="row" fxLayoutAlign="space-between center">
                              <h2>{{'REQUERIMIENTOSV3.PASO3.WARN_TEST_EMAIL' | translate}}</h2>
                              <mat-icon class="ml-20 s-40">warning</mat-icon>
                            </div>
                          </div>
                          <div class="contactoSoporte" fxLayout="row"  style="margin-top:20px">
                          <mat-icon matSuffix>help</mat-icon>
                          {{'REQUERIMIENTOSV3.PASO3.CONTAC' | translate}}
                          </div>



                        </div>
                        </mat-card>
                      </div>

                    <ng-container *ngIf="tipoUsuarioAdministrador">
                          <div fxLayout="row" fxLayoutAlign="center center" style="margin-top:40px">
                            <button  mat-raised-button color="primary" matStepperPrevious>
                            {{'REQUERIMIENTOS.BOTONES.ANTERIOR' | translate}}
                            </button>
                              <button mat-raised-button color="primary" class="ml-20" matStepperNext>
                            {{'REQUERIMIENTOS.BOTONES.SIGUIENTE' | translate}}
                            </button>
                          </div>


                        </ng-container >
                        <ng-container *ngIf="!tipoUsuarioAdministrador">
                          <div fxLayout="row" fxLayoutAlign="center center" style="margin-top:40px">
                            <button  mat-raised-button color="primary" matStepperPrevious>
                            {{'REQUERIMIENTOS.BOTONES.ANTERIOR' | translate}}
                            </button>
                              <button mat-raised-button color="primary" class="ml-20" (click)="validacionBandera(stepper)" *ngIf="!testEmail">
                            {{'REQUERIMIENTOS.BOTONES.SIGUIENTE' | translate}}
                            </button>
                              <button mat-raised-button color="primary" class="ml-20" matStepperNext *ngIf="testEmail">
                            {{'REQUERIMIENTOS.BOTONES.SIGUIENTE' | translate}}
                            </button>
                          </div>

                        </ng-container >


                </mat-step>

                <mat-step [stepControl]="">

                    <ng-template matStepLabel>{{'REQUERIMIENTOSV3.PASO4.TITULO' | translate}}</ng-template>
                    <form [formGroup]="formPreguntas2" (ngSubmit)="saveData()">
                    <div fxFlex="1 0 auto" fxLayout="column">
                      <ng-container *ngFor="let item of catalogoPreguntas; let i=index">
                        <p [innerHTML]="item.question">{{item.question}}</p>
                        <ng-container *ngIf="item.typeQuestion==1">
                          <mat-form-field appearance="outline" fxFlex="50" >
                            <textarea  matInput   formControlName="question{{i}}"></textarea>
                            <mat-error>{{'REQUERIMIENTOSV3.MENSAJES.MENSAJE_RESPUESTA_REQ' | translate}}</mat-error>
                          </mat-form-field>
                        </ng-container>
                        <ng-container *ngIf="item.typeQuestion==2">
                        <div fxLayout="row" fxLayoutAlign="star center">
                                <mat-radio-group  formControlName="question{{i}}">
                                    <mat-radio-button  color="warn" *ngFor="let opciones of item.answers;" [value]="opciones.idAnswer.toString()" fxLayout="column">
                                        <span >{{opciones.answers}}</span>
                                    </mat-radio-button>
                                </mat-radio-group>
                            </div>
                        </ng-container>
                      </ng-container>
                        <ng-container  *ngIf="tipoUsuarioAdministrador">
                        <div  fxLayoutAlign="center center">
                          <button mat-raised-button color="primary" [disabled]="tipoUsuarioAdministrador">
                            {{'REQUERIMIENTOSV3.PASO4.BTN_VALIDAR_ENVIAR' | translate}}
                          </button>
                        </div>
                      </ng-container>

                      <ng-container *ngIf="!tipoUsuarioAdministrador">
                        <div  fxLayoutAlign="center center">
                          <button mat-raised-button color="primary" [disabled]="!cuestionarioCompletas||validacionCuestionario" (click)="guardarFormulario();setBanderasRequerimientos('question')" >
                            {{'REQUERIMIENTOSV3.PASO4.BTN_VALIDAR_ENVIAR' | translate}}
                          </button>
                        </div>
                      </ng-container>
                    </div>

                  </form>

                  <ng-container *ngIf="tipoUsuarioAdministrador">
                    <div fxLayout="row" fxLayoutAlign="center center" style="margin-top:40px">
                      <button mat-raised-button color="primary" matStepperPrevious >
                        {{'REQUERIMIENTOS.BOTONES.ANTERIOR' | translate}}
                      </button>
                      <button mat-raised-button color="primary" class="ml-20" matStepperNext>
                        {{'REQUERIMIENTOS.BOTONES.SIGUIENTE' | translate}}
                      </button>
                    </div>
                  </ng-container >
                  <ng-container *ngIf="!tipoUsuarioAdministrador">
                    <div fxLayout="row" fxLayoutAlign="center center" style="margin-top:40px">
                      <button mat-raised-button color="primary" matStepperPrevious type="button" >
                        {{'REQUERIMIENTOS.BOTONES.ANTERIOR' | translate}}
                      </button>
                      <button mat-raised-button color="primary" class="ml-20" matStepperNext *ngIf="validacionCuestionario">
                        {{'REQUERIMIENTOS.BOTONES.SIGUIENTE' | translate}}
                      </button>
                    </div>
                  </ng-container >


                </mat-step>

                <mat-step [stepControl]="">

                  <ng-template matStepLabel>{{'REQUERIMIENTOSV3.PASO5.TITULO' | translate}}</ng-template>

                  <div fxFlex="1 0 auto" fxLayout="column">

                    <p class="pb-32">{{'REQUERIMIENTOSV3.PASO5.SUB_TITULO' | translate}}</p>

                    <p class="pb-32">
                      {{'REQUERIMIENTOSV3.PASO5.PARRAFO1' | translate}}
                    </p>

                    <p style="font-size: 40px;color:#F5A71E;font-weight:bold;margin:0;">{{'REQUERIMIENTOSV3.PASO5.PARRAFO2' | translate}}</p>

                    <span><span style="font-size:10px;font-weight:bold">{{'REQUERIMIENTOSV3.PASO5.PARRAFO3_1' | translate}}</span>{{'REQUERIMIENTOSV3.PASO5.PARRAFO3_2' | translate}}</span>

                    <span><span style="font-size:10px;font-weight:bold">{{'REQUERIMIENTOSV3.PASO5.PARRAFO4_1' | translate}}</span>{{'REQUERIMIENTOSV3.PASO5.PARRAFO4_2' | translate}}</span>
                    <div fxLayout="column" fxLayoutAlign="center center">
                      <p style="font-size: 40px;color:#F5A71E;font-weight:bold;margin:20;"> {{'REQUERIMIENTOSV3.PASO5.PARRAFO5' | translate}}  </p>
                    </div>


                  </div>

                  <div fxLayout="row" fxLayoutAlign="center center" style="margin-top:40px">
                    <button mat-raised-button color="primary" matStepperPrevious>
                      {{'REQUERIMIENTOS.BOTONES.ANTERIOR' | translate}}
                    </button>
                    <ng-container *ngIf="!tipoUsuarioAdministrador">
                      <button *ngIf="!requirements" mat-raised-button color="primary" class="ml-20" (click)="setBanderasRequerimientos('validacion')">
                        {{'REQUERIMIENTOSV3.PASO5.BTN_FINALIZAR' | translate}}
                      </button>
                      <button *ngIf="requirements" mat-raised-button color="accent" class="ml-20">
                        {{'REQUERIMIENTOSV3.PASO5.BTN_FINA_REQUE' | translate}}
                      </button>
                    </ng-container>
                  </div>

                </mat-step> -->

            </mat-horizontal-stepper>
            <!-- / HORIZONTAL STEPPER EXAMPLE -->

        </div>





    </div>
    <!-- / CONTENT -->

</div>
